<template>
  <div class="content-box">
    <div class="tree-list heitani">
      <div class="lefthead">
        <span>{{ systemReadListparam.rows.listName }}</span>
      </div>
      <div style="margin-top: 10px">
        <!-- <div class="leftpro activepro">如何注册</div>
        <div class="leftpro">逻辑检索说明</div>
        <div class="leftpro">一般检索使用说明</div> -->
        <div class="tree">
          <div class="titles">
            <!-- <span>《儒藏》精华篇 </span> -->
            <div>
              <img src="/static/search/sibu.png" style="width: 18px;height: 16px;margin-right: 10px">
            </div>
            <span>书单介绍 </span>
            <!-- <el-input
              size="mini"
              placeholder="请输入内容"
              suffix-icon="el-icon-search"
              v-model="fenlei"
              @keyup.enter.native="fenleiSearch()"
            >
            </el-input> -->
            <!-- <i
                  :class="
                    searchTree.tree === 1
                      ? 'el-icon-caret-bottom'
                      : 'el-icon-caret-right'
                  "
                  @click="searchTree.tree = searchTree.tree === 1 ? 0 : 1"
                  class="right-icon"
                ></i> -->
          </div>
          <div class="treeitem">
            <!-- <transition name="fade-in"> -->
            <!-- <el-tree
                  :empty-text="emptyText"
                  ref="treeList"
                  :data="searchResult.tree"
                  :check-on-click-node="true"
                  :expand-on-click-node="false"
                  @check="setSearchFilter()"
                  @node-click="isornotpermit"
                  node-key="id"
                  :props="searchTreeProps"
                  :filter-node-method="getFilter"
                  show-checkbox
                >
                  <span class="span-ellipsis" slot-scope="{ node, data }">
                    <span
                      v-show="!isSimple && data.totalNum > 0"
                      class="xinghao"
                      >*</span
                    ><span
                      :style="{
                        color: !isSimple && data.isPermit == 0 ? '#bbb' : '',
                      }"
                      >{{ node.label }}</span
                    >
                  </span>
                </el-tree> -->
            <!-- <el-checkbox-group
                class="padding-left left-width"
                v-model="checkIds"
              >
                <el-checkbox
                  v-for="item in catalist"
                  :label="item.showName"
                  :key="item.showName"
                  :value="item.showName"
                  @click.stop.native
                  @change="search()"
                  style="width: 100%; margin-right: 0; height: 26px"
                >
                  {{ item.showName }}
                </el-checkbox>
              </el-checkbox-group> -->
            <!-- </transition> -->
            {{ systemReadListparam.rows.description }}
            <!-- <div class="second-btn-box">
              <el-button
                type="primary"
                @click="clearsearch()"
                class="second-btn"
                size="mini"
              >
                清除选项
              </el-button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="select-content flex-grow">
      <div style="display: flex;justify-content: space-between">
        <p style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #573E0D;">书单列表
          <span style="font-family: PingFangSC, PingFang SC;font-weight: 400;font-size: 14px;color: #573E0D;">
         共{{ systemReadListparam.rows.bookCount }}本
      </span>
        </p>
        <div style="width: 30%">
          <el-input
            size="medium"
            placeholder="请输入内容"
            v-model="newParam.keyword"
            @keyup.enter.native="search(false)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              v-loading="isSearching"
              @click="search(false)"
            ></el-button>
          </el-input>
        </div>
      </div>
      <!-- <h2>如何注册</h2> -->

      <!-- <p>
        1.霍州李白先生管语诸生日:
        [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也2.始至，郡中有粤行者，得李白雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。1.霍州李白先生管语诸生日:
        [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也2.始至，郡中有粤行者，得李白雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。1.霍州李白先生管语诸生日:
        [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也2.始至，郡中有粤行者，得李白雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。1.霍州李白先生管语诸生日:
        [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也2.始至，郡中有粤行者，得李白雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。1.霍州李白先生管语诸生日:
        [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也2.始至，郡中有粤行者，得李白雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。1.霍州李白先生管语诸生日:
        [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也2.始至，郡中有粤行者，得李白雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。
      </p>
         v-infinite-scroll="newload"
          infinite-scroll-disabled="newdisabled"
          infinite-scroll-distance="20"
      -->

      <div class="booklist">
        <div class="booklistc" v-if="bookList && bookList.length">
          <div class="booklisten">
            <div
              class="bookitem"
              :key="index"
              v-for="(item, index) in bookList"
            >
              <div class="leftimg" @click.stop="gotoRead(item)" style="position: relative">
                <img
                  v-if="item.categoryName.includes('其他')"
                  src="/static/homenew/5New5.png"
                  alt=""
                  style="width: 139px;height: 174px;"
                />
                <img
                  v-else-if="item.categoryName.includes('經部')"
                  src="/static/homenew/1New1.png"
                  alt=""
                  style="width: 139px;height: 174px;"
                />
                <img
                  v-else-if="item.categoryName.includes('史部')"
                  src="/static/homenew/2New2.png"
                  alt=""
                  style="width: 139px;height: 174px;"
                />
                <img
                  v-else-if="item.categoryName.includes('子部')"
                  src="/static/homenew/3New3.png"
                  alt=""
                  style="width: 139px;height: 174px;"
                />
                <img v-else src="/static/homenew/4New4.png" alt="" style="width: 139px;height: 174px;"/>
                <div style="position: absolute;top:30px;left:30px;writing-mode: vertical-rl;
  text-orientation: upright;
  white-space: nowrap; font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #573E0D;" :title="item.bookName">
                  {{ handleBracket(item.bookName) }}
                </div>
              </div>
              <div class="righttext" @click.stop="gotoRead(item)">
                <div class="topbox">
                  <p class="toptext">{{ item.bookName }}</p>
                </div>
                <div class="bottomtext">
                  <p>{{ item.writer }}</p>
                  <p>{{ item.bookVersion }}</p>
                  <p>{{ item.categoryName }}</p>
                </div>
              </div>
            </div>
            <div  style="width:100%;margin: 20px auto; text-align: center;padding-bottom: 15px">
              <el-pagination
                style="margin: 0 auto; text-align: center"
                background
                layout="prev, pager, next"
                :total="newParam.total"
                @current-change="pageChange"
                :current-page="newParam.pageNum"
                :page-size="newParam.pageSize"
              >
              </el-pagination>
            </div>
          </div>
        </div>

        <el-empty
          v-else
          :image-size="200"
          description="暂无数据"
          image="/static/icon/1.gif"
        ></el-empty>
        <!-- <div class="bookitem">
          <div class="leftimg">
            <img src="/static/detail/book.jpg" alt="" />
          </div>
          <div class="righttext">
            <p class="toptext">六韜</p>
            <p class="bottomtext">
              [春秋] 鄧析 撰·四部叢刊景明本·北京大學-字節跳動古籍開放文本庫
            </p>
          </div>
        </div>
        <div class="bookitem">
          <div class="leftimg">
            <img src="/static/detail/book.jpg" alt="" />
          </div>
          <div class="righttext">
            <p class="toptext">六韜</p>
            <p class="bottomtext">
              [春秋] 鄧析 撰·四部叢刊景明本·北京大學-字節跳動古籍開放文本庫
            </p>
          </div>
        </div>
        <div class="bookitem">
          <div class="leftimg">
            <img src="/static/detail/book.jpg" alt="" />
          </div>
          <div class="righttext">
            <p class="toptext">六韜</p>
            <p class="bottomtext">
              [春秋] 鄧析 撰·四部叢刊景明本·北京大學-字節跳動古籍開放文本庫
            </p>
          </div>
        </div>
        <div class="bookitem">
          <div class="leftimg">
            <img src="/static/detail/book.jpg" alt="" />
          </div>
          <div class="righttext">
            <p class="toptext">六韜</p>
            <p class="bottomtext">
              [春秋] 鄧析 撰·四部叢刊景明本·北京大學-字節跳動古籍開放文本庫
            </p>
          </div>
        </div> -->
        <!-- <p v-if="newloading">加载中...</p>
        <p v-if="noMore">以上就是本次檢索的所有結果</p> -->
      </div>

      <!-- <div style="text-align: center; margin-top: 20px"> -->
      <!-- <el-pagination
          background
          layout="prev, pager, next"
          :total="1000"
          hide-on-single-page
        >
        </el-pagination> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import {
  //   getInfo,
  //   getlistByIdsApi,
  // getBookList,
  //   booksTree,
  essearch,
  // getCategoryNode,
  // getDynastyList,
  // getWriterList,
  // getMainSum,
  // getNoteSum,
  //   readinglistBySearch,
  newGetCategoryNode,
  //   newGetWriterList,
  //   exportSearchResult,
  //   getHitCount,
  //   addLatest
  getReadListNew
} from "@/api/api"
export default {
  name: "Books",
  data () {
    return {
      fenlei: "",
      // searchFilter: {

      //   writerIds: [],
      //   dynastyIds: [],
      //   bookReadingListIds: []
      // },

      checkIds: [],
      catalist: [],//分类
      keyword: '',
      newParam: {
        pageSize: 28,
        pageNum: 1,
        total: 0,
        keyword: "",
        // type: 0,
        searchType: "3",
        // sort: "0", //排序 0 正序 1倒序
        // sortType: 0, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
        categoryIds: "",
        categoryNames: [],
        bookReadingListIds: "",//书单
        // writerIds: "",
        // dynastyIds: "",
        // bookReadingListIds: "",
        // writerInitials: "",
        // bookIds: "",
        // advaList: [],
        // hitCountType: 0,
        // isInnerSearch: 0,//0 全局 1书内检索
        // searchAccuracyType: 1,
        // isOnlyPermit: 1,//是否全库 0 全局 1仅授权
        // textType: "0"
      },
      bookList: [],
      newloading: false, //滚动加载
      isSearching: false,
      systemReadListparam: {
        pageNum: 1,
        pageSize: 10,
        rows: [],
        total: 0
      }
    }
  },
  computed: {
    noMore () {
      // if (this.isSearching) {
      return this.newParam.total < this.newParam.pageSize
      // }
      // } else {
      //   return this.empsearch.pageNum >= Math.ceil(this.empsearch.total / this.empsearch.pageSize)

      // }
    },
    newdisabled () {
      return this.newloading || this.noMore
    },
  },
  mounted () {


    const { params } = this.$route
    if (params.listid) { this.newParam.bookReadingListIds = params.listid }
    this.getCategoryNodeData({})
    this.getSystemReadList()
    this.search(false)



  },
  methods: {
    handleBracket(str){
      let strPar=str.length > 7 ? str.slice(0, 6) + '…' : str
      strPar=strPar.replace(/\(/g, '︵')
      strPar=strPar.replace(/\)/g, '︶')
      strPar=strPar.replace(/\{/g, '︷')
      strPar=strPar.replace(/\}/g, '︸')
      strPar=strPar.replace(/\﹝/g, '︹')
      strPar=strPar.replace(/\﹞/g, '︺')
      strPar=strPar.replace(/\〈/g, '︿')
      strPar=strPar.replace(/\〉/g, '﹀')
      strPar=strPar.replace(/\《/g, '︽')
      strPar=strPar.replace(/\》/g, '︾')
      strPar=strPar.replace(/\「/g, '﹁')
      strPar=strPar.replace(/\」/g, '﹂')
      strPar=strPar.replace(/\『/g, '﹃')
      strPar=strPar.replace(/\』/g, '﹄')
      strPar=strPar.replace(/\【/g, '︻')
      strPar=strPar.replace(/\】/g, '︼')
      strPar=strPar.replace(/1/g, '一')
      strPar=strPar.replace(/2/g, '二')
      strPar=strPar.replace(/3/g, '三')
      strPar=strPar.replace(/4/g, '四')
      strPar=strPar.replace(/5/g, '五')
      strPar=strPar.replace(/6/g, '六')
      strPar=strPar.replace(/7/g, '七')
      strPar=strPar.replace(/8/g, '八')
      strPar=strPar.replace(/9/g, '九')
      strPar=strPar.replace(/0/g, '○')
      return strPar
    },
    getSystemReadList () {
      let { pageNum, pageSize } = this.systemReadListparam
      getReadListNew({ pageNum, pageSize, isPublic: 1 }).then(d => {
        console.log(d)

        d.rows.forEach(element => {
          if (element.listId == this.$route.params.listid) {
            this.systemReadListparam.rows = element
          }
        })
        this.systemReadListparam.total = d.total
        console.log(this.systemReadListparam, 'this.systemReadListparam')
      })
    },
    gotoBookDetail (item) {
      const url = this.$router.resolve("/bookDetail?id=" + item.id)
      window.open(url.href)
    },
    gotoRead (item) {
      // $router.push({
      //               name: 'Read',
      //               query: {
      //                 bookId: item.id,
      //                 bookName: item.bookName,
      //               },
      //             })

      const url = this.$router.resolve("/read?bookId=" + item.id + '&bookName=' + item.bookName+'&from=shudantuijian')
      window.open(url.href)
    },
    clearsearch () {
      this.checkIds = []
      this.newParam = {
        pageSize: 28,
        pageNum: 1,
        total: 0,
        keyword: "",
        searchType: "3",
        categoryIds: "",
        bookReadingListIds: "",//书单

      }
      this.search(false)
    },
    newload () {
      console.log('ddd')
      this.newloading = true
      setTimeout(() => {
        // if (this.isSearching) {
        // this.newloading = false
        this.newParam.pageNum += 1
        this.search(true)
        // }
      }, 2000)
    },
    pageChange (val) {
      this.newParam.pageNum = val
      this.search(true)
    },
    search (scrollk = false) {
      // console.log(this.newParam, 'this.newParam')
      // if (scroll) {
      // this.newloading = false
      if (!scrollk) {
        this.newParam.pageNum = 1
      }
      this.isSearching = true
      // }
      this.newParam.categoryNames = this.checkIds
      essearch(this.newParam).then(
        (data) => {
          // this.showmenu = false
          this.isSearching = false
          if (data.code == 200
          ) {

            // if (data.data.code == 500) {
            //   return this.$message.warning(data.data.msg)
            // }
            // console.log(data.bookList, 'dsfdata')
            // if (scrollk) { this.bookList = [...this.bookList, ...data.data.bookList] } else {
            this.bookList = data.data.bookList
            // }
            this.newParam.total = data.data.totalNum
            this.newloading = false
          }
        }),
        () => (this.isSearching = false)
    },


    fenleiSearch () {

      this.getCategoryNodeData({ keyword: this.fenlei })
    },
    getCategoryNodeData (que) {
      this.emptyText = "查詢中..."
      //   parentId: "0",
      //   nodeType: "category",
      // }).then((data) => {
      // let isOnlyPermit = this.newParam.isOnlyPermit
      // this.emptyText = "查詢中..."
      // getHitCount({
      //   hitCountType: 2,
      // }).then((data) => {
      //   this.searchResult.tree = data.data.tree

      //   this.$forceUpdate()
      //   if (this.isSearching) {
      //     this.emptyText = "暫無數據"
      //     this.$nextTick(
      //       () =>

      //         this.$refs.treeList && this.$refs.treeList.filter(this.isSimple)
      //     )
      //   } else {
      //     this.emptyText = "暫無授權文獻"
      //     this.$nextTick(
      //       () =>
      //         this.$refs.defaultSearchTree &&
      //         this.$refs.defaultSearchTree.filter(this.isSimple)
      //     )
      //   }

      // })
      // this.emptyText = "查詢中..."
      newGetCategoryNode(que).then((data) => {
        this.catalist = data.data

        // this.$forceUpdate()
        // if (this.isSearching) {
        //   this.emptyText = "暫無數據"
        //   this.$nextTick(
        //     () =>

        //       this.$refs.treeList && this.$refs.treeList.filter(this.isSimple)
        //   )
        // } else {
        //   this.emptyText = "暫無授權文獻"
        //   this.$nextTick(
        //     () =>
        //       this.$refs.defaultSearchTree &&
        //       this.$refs.defaultSearchTree.filter(this.isSimple)
        //   )
        // }

      })
    },
  }

}
</script>

<style lang="less" scoped>
@primary-color: #f4f0e8;
@first-color: #2c7e8d;
@secont-color: #666666;
@three-color: #999999;
@four-color: #333333;
@PingFang-SC-Medium: PingFang-SC-Medium;
@PingFangSC-Regular: PingFangSC-Regular;
@PingFang-SC-Bold: PingFang-SC-Bold;
@PingFang-SC-ExtraLight: PingFang-SC-ExtraLight;
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #E9B63E;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #2c7e8d;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #2c7e8d;
  border-color: #2c7e8d;
}
/deep/.el-pagination {
  width: 100%;
}
/deep/.el-input-group__append{
  background: #795636;
  color: #fff;
}
/deep/.el-input .is-active .el-input__inner,
/deep/.el-input__inner:focus {
  border-color: #E9B63E;
}
p {
  margin: 0;
  padding: 0;
}
.booklist {
  height: 70vh;
  // margin-top: 10px;
  overflow-y: hidden;

  .booklistc {
    cursor: pointer;
    width: 100%;
    // height: 100%;

    overflow-y: auto;
    .booklisten {
      height: 72vh;
      display: flex;
      // overflow-y: scroll;
      flex-wrap: wrap;
      // overflow-y: hidden;
      // overflow-y: auto;
      // justify-content: space-between;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }

  .bookitem {
    width: 164px;
   // height: 120px;
    padding: 16px;
   // display: flex;

   // align-items: flex-start;
    //border: 1px solid #eee;
    border-radius: 3px;
    margin: 4px;

    .righttext {
      flex: 1;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #2B2B2B;
      .bottomtext {
        p {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; /* 限制行数为5 */
          overflow: hidden;
        }
        margin-top: 4px;

        line-height: 1.6;
      }
    }
    img {
      width: 60px;
      height: auto;
      margin-right: 5px;
      transition: transform 0.5s ease;
    }
    // .topbox {
    //   width: 200px;
    //   white-space: nowrap; /* 防止文本换行 */
    //   overflow: hidden; /* 隐藏溢出的文本 */
    //   text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
    // }
    .toptext {
      margin-top: 5px;
      text-align: left;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #573E0D;
      letter-spacing: 0;
      line-height: 25px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* 限制行数为5 */
      overflow: hidden;
    }
    .bottomtext {
      text-align: left;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 1.5;
      font-family: PingFangSC-Regular;
    }
  }
  .bookitem:hover {
    img {
      transform: scale(1.1);
    }
    transform: scale(1.01);
    // .booklistconse {
    // background: rgba(255, 255, 255, 0.6);
    background: #FAF7F2;
    //box-shadow: 0px 4px 8px 0px rgba(209, 203, 189, 0.4);
    // border-radius: 4px;
    // }
  }
}
.second-btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  padding: 10px 24px;
  // background: #fff;
  // border-top: 0.1rem solid #ccc;
  position: absolute;
  bottom: 0;
  left: 0;
  .el-button--primary {
    background: #2c7e8d;
    border-color: #2c7e8d;
  }
}
.content-box {
  width: 100%;
  display: -webkit-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow: auto;
  padding: 16px 10px;
  background: rgb(244, 240, 232);
  .lefthead {
    // height: 90px;
    letter-spacing: 0;
    //text-align: center;
    //border-bottom: 1px solid #eeeeee;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #573E0D;
    span {
      display: inline-block;
      //   border-bottom: 2px solid #2c7e8d;
      //line-height: 54px;
    }
    p {
      font-size: 14px;
      font-weight: 500;
      color: black;
      line-height: 1.5;
    }
  }
}
.content-box .tree-list {
  margin-right: 16px;
 padding: 25px;
  width: 300px;
  position: relative;
  background: #FEFBF4;
  border-radius: 4px;
  overflow: hidden;
  height: 86vh;
  overflow-y: hidden;
  border-radius: 8px;
  .el-input {
    width: 180px;
  }
  .tree {
    height: 32%;
    padding: 12px 0;
    .titles {
      display: flex;
      margin-bottom: 15px;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #573E0D;
    }
    .treeitem {
      margin-top: 5px;
      height: 65vh;
      overflow-y: auto;
      overflow-x: hidden;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #2B2B2B;
    }
  }
  .leftpro {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: left;
    line-height: 2.5;
    font-weight: 400;
    padding: 0 10px;
    cursor: pointer;
  }
  .activepro {
    background: #2c7e8d;
    border-radius: 4px;
    color: #ffffff;
  }
}

.content-box .select-content {
  -webkit-box-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 1.4rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  min-height: 86vh;
  background: #fff;
  h2 {
    font-family: PingFang-SC-Bold;
    font-size: 32px;
    color: #2c7e8d;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
    font-weight: 700;
  }
  p {
    font-family: PingFang-SC-Medium;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/gobooks/index.vue